import styled from "styled-components";

export const ButtonPadding = styled.div`
  display : flex;
  gap : 8px;
`;

